import React from 'react'
import ReactDOM from 'react-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import Breadcrumb from './Breadcrumb'

class Breadcrumbs extends React.Component {

  render() {
    return (
      <div className="row" id="breadcrumb">
        <div className="col-10 offset-1">
         <div className="row">
            { this.props.breadcrumbs.map((breadcrumb) => (
              <Breadcrumb
                key={breadcrumb}
                title={breadcrumb}
                selected={breadcrumb === this.props.breadcrumb}
                count={this.props.breadcrumbs.length} />
            ))}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  breadcrumb: state.breadcrumb,
})

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Breadcrumbs)


// WEBPACK FOOTER //
// ./app/javascript/components/components/Breadcrumbs.jsx